export default {
  period: 'Período de análise',
  mixMode: 'Modo do mix',
  progress: '{done} de {total} orçamentos calculados',
  kpi: 'KPI',
  delete: 'Excluir',
  cancel: 'Cancelar',
  deleteTitle: 'Excluir simulação de orçamento',
  deleteConfirm: 'Excluir "{name}" e os planos de todos os seus orçamentos? Esta ação não pode ser desfeita.',
  waiting: 'Os orçamentos estão sendo calculados. Os gráficos aparecem à medida que cada um termina.',
  totalSaturationCurve: 'Curva de Saturação Total',
  roasByBudget: 'ROAS Total em diferentes Níveis de Orçamento',
  mixByBudget: 'Mix de Mídia em diferentes Níveis de Orçamento',
  budgetLevel: 'Orçamento',
  ofReference: '{pct}% da referência',
  // XLSX download
  xlsxSimulation: 'Simulação de orçamento',
  xlsxGridBudgets: 'Orçamentos da grade ({unit})',
  xlsxPctOfReference: '% da referência',
  xlsxOptimalZones: 'Zonas Ótimas',
  xlsxZone: 'Zona',
  xlsxFrom: 'De',
  xlsxTo: 'Até',
  xlsxFrozenMix: 'Mix Fixo',
  xlsxShare: 'Participação (%)',
  xlsxPeriod: 'Período'
}
